export enum ShapefileType {
  RWS = 'RWS',
  FCD = 'FCD'
}



// WEBPACK FOOTER //
// ./src/app/models/enums/shapefiletype.ts